export const getCountries = (data?: {
    results: CountryDictionary[]
}) => (data?.results ?? [])
  .map(({ alta_code, code, name, }: { alta_code: string, code: string, name: string }) => ({ id: alta_code, label: name, code }))
